export const initial = {
  typ: null,
  datum: null,
  jahr: null,
  bearbeiter: null,
  vitalitaet: null,
  ueberlebensrate: null,
  entwicklung: null,
  ursachen: null,
  erfolgsbeurteilung: null,
  umsetzungAendern: null,
  kontrolleAendern: null,
  bemerkungen: null,
  lrDelarze: null,
  flaeche: null,
  lrUmgebungDelarze: null,
  vegetationstyp: null,
  konkurrenz: null,
  moosschicht: null,
  krautschicht: null,
  strauchschicht: null,
  baumschicht: null,
  idealbiotopUebereinstimmung: null,
  handlungsbedarf: null,
  flaecheUeberprueft: null,
  planVorhanden: null,
  deckungVegetation: null,
  deckungNackterBoden: null,
  deckungApArt: null,
  jungpflanzenVorhanden: null,
  vegetationshoeheMaximum: null,
  vegetationshoeheMittel: null,
  gefaehrdung: null,
  apberNichtRelevant: null,
  apberNichtRelevantGrund: null,
  ekfBemerkungen: null,
}

export const simpleTypes = {
  typ: 'string',
  datum: 'date',
  jahr: 'number',
  bearbeiter: 'uuid',
  vitalitaet: 'string',
  ueberlebensrate: 'number',
  entwicklung: 'number',
  ursachen: 'string',
  erfolgsbeurteilung: 'string',
  umsetzungAendern: 'string',
  kontrolleAendern: 'string',
  bemerkungen: 'string',
  lrDelarze: 'string',
  flaeche: 'number',
  lrUmgebungDelarze: 'string',
  vegetationstyp: 'string',
  konkurrenz: 'string',
  moosschicht: 'string',
  krautschicht: 'string',
  strauchschicht: 'string',
  baumschicht: 'string',
  idealbiotopUebereinstimmung: 'number',
  handlungsbedarf: 'string',
  flaecheUeberprueft: 'number',
  planVorhanden: 'boolean',
  deckungVegetation: 'number',
  deckungNackterBoden: 'number',
  deckungApArt: 'number',
  jungpflanzenVorhanden: 'boolean',
  vegetationshoeheMaximum: 'number',
  vegetationshoeheMittel: 'number',
  gefaehrdung: 'string',
  apberNichtRelevant: 'boolean',
  apberNichtRelevantGrund: 'string',
  ekfBemerkungen: 'string',
}
